import { AbstractControl, FormArray } from '@angular/forms';

import { FileModel, FileModelBuilder } from './file.model';
import { SectionContent } from './sectionContent.model';

export class PresentationModel {
    public id: string;
    public creationDate: any;
    public theme: string;
    public modificationDate: any;
    public sections: Section[] = [];
    public thumbnailPath: string;

    constructor(
        public layout?: string,
        public name?: string,
        public description?: string,
        public owners: object = {}
    ) { }

    public hasPendingUploads(): boolean {
        for (const section of this.sections) {
            if (!section.files) { continue; }

            for (const file of section.files) {
                if (file instanceof FileModelBuilder) { return true; }
            }
        }

        return false;
    }

    public hasUploadedFiles(): boolean {
        return this.sections
            .filter(section =>
                section
                && section.files
                && !(section.files[0] instanceof FileModelBuilder))
            .length >= 1;
    }
}

export class Section {
    constructor(public type?: string, public content?: SectionContent, public files?: FileModel[], public formControls: AbstractControl[] = []) { }
}



// WEBPACK FOOTER //
// ./src/app/views/presentations/models/presentation.model.ts